import { TLanguages } from "@languages/languageData";

export const currencyFormat = (value: number, language: TLanguages) => {
  const currencyType = {
    "en-US": "USD",
    es: "EUR",
    "pt-BR": "BRL"
  };

  return new Intl.NumberFormat(language, {
    style: "currency",
    currency: "BRL" // currencyType[language]
  }).format(value);
};
